module.exports = __webpack_public_path__ + "media/src/img/doc-icon-5d4a5dc9a89f598ccdf3d80785e8e681.svg";